/** @format */

import NotificationManager from 'react-notifications/lib/NotificationManager';
import {
	buyProduct,
	getAllProductPlans,
	getProductPlan,
	postProductPlan,
	getProductFeatures,
	updateProductPlan,
	deleteProductPlan,
	getCurrentPlan,
	// getCompanyProductHistory,
	changeCompanyProduct,
	// cancelProduct,
} from '../APIs';
// import { formatDays } from "../HelperFunctions";

export const getAllProductReducer = async (
	id,
	flag,
	updateState,
	setIsLoading
) => {
	setIsLoading(true);
	try {
		const res = await getAllProductPlans(id);
		let formatedData = res.data.data;
		if (flag) {
			formatedData = formatedData.filter((item) => item.type === flag);
		}
		updateState(formatedData);
	} catch (e) {
		console.log(e);
		NotificationManager.error(e.response.data || 'Something Went Wrong!');
	} finally {
		setIsLoading(false);
	}
};

export const getProductReducer = async (
	id,
	updateState,
	setSelectedOption,
	setIsLoading
) => {
	setIsLoading(true);
	try {
		const res = await getProductPlan(id);
		const item = res.data.data;
		updateState(item);

		setSelectedOption(
			item.features.map((item) => {
				return {
					value: item._id,
					label: item.description,
				};
			})
		);
	} catch (e) {
		console.log(e);
		NotificationManager.error(e.response.data || 'Something Went Wrong!');
	} finally {
		setIsLoading(false);
	}
};
export const getProductFeaturesReducer = async (updateState) => {
	try {
		const res = await getProductFeatures();
		const formatedData = res.data.map((item) => {
			return {
				value: item._id,
				label: item.description,
			};
		});
		updateState(formatedData);
	} catch (e) {
		console.log(e);
		NotificationManager.error(e.response.data || 'Something Went Wrong!');
	}
};

export const postProductReducer = async (
	values,
	updateState,
	setRowLoading,
	setmodel,
	setIsLoading
) => {
	setIsLoading(true);
	try {
		const res = await postProductPlan(values);
		if (res.data.message === 'PRODUCT CREATED SUCCESSFULLY') {
			NotificationManager.success(res.data.message);
			setmodel(false);
			// getAllProductReducer(updateState, setRowLoading);
		}
	} catch (e) {
		console.log(e);
		NotificationManager.error(e.response.data || 'Something Went Wrong!');
	} finally {
		setIsLoading(false);
	}
};
export const updateProductReducer = async (
	id,
	values,
	updateState,
	setRowLoading,
	setmodel,
	setIsLoading
) => {
	setIsLoading(true);
	try {
		const res = await updateProductPlan(id, values);
		if (res.data.message === 'PRODUCT UPDATED SUCCESSFULLY') {
			NotificationManager.success(res.data.message);
			setmodel(false);
			// getAllProductReducer(updateState, setRowLoading);
		}
	} catch (e) {
		console.log(e);
		NotificationManager.error(e.response.data || 'Something Went Wrong!');
	} finally {
		setIsLoading(false);
	}
};
export const showProductOnHomePageReducer = async (
	payload,
	status,
	updateState,
	setIsLoading
) => {
	try {
		const res = await updateProductPlan(payload._id, {
			...payload,
			homepage: status === true ? true : false,
		});
		if (res.data.message === 'PRODUCT UPDATED SUCCESSFULLY') {
			NotificationManager.success(res.data.message);
			getAllProductReducer('', 'COMMON', updateState, setIsLoading);
		}
	} catch (e) {
		console.log(e);
		NotificationManager.error(e.response.data || 'Something Went Wrong!');
	} finally {
	}
};
export const deleteProductReducer = async (id, upDateState, setIsLoading) => {
	try {
		const res = await deleteProductPlan(id);
		if (res.data.message === 'PRODUCT DELETED SUCCESSFULLY') {
			NotificationManager.success(res.data.message);
			// getAllProductReducer(upDateState, setIsLoading);
		}
	} catch (e) {
		console.log(e);
		NotificationManager.error(e.response.data || 'Something Went Wrong!');
	}
};

export const buyProductPlan = async (payload, navigate, setIsLoading) => {
	setIsLoading(true);
	try {
		const res = await buyProduct(payload);
		debugger;
		if (res.data) {
			window.location = res.data.link;
		}
	} catch (e) {
		console.log(e);
		NotificationManager.error(e.response.data || 'Something Went Wrong!');
	} finally {
		setIsLoading(false);
	}
};
export const getCurrentPlanReducer = async (
	updateState,
	setUpgradeNowModal
) => {
	try {
		const res = await getCurrentPlan();
		if (res.data) {
			updateState(res.data);
			if (res.data.isExpired) {
				setUpgradeNowModal(true);
			}
		}
	} catch (e) {
		console.log(e);
		NotificationManager.error(e.response.data || 'Something Went Wrong!');
	}
};
export const getCompanyProductHistoryReducer = async (
	id,
	updateState,
	setIsLoading
) => {
	setIsLoading(true);
	try {
		// const res = await getCompanyProductHistory(id);
		if (res.data) {
			updateState(res.data);
		}
	} catch (e) {
		console.log(e);
		NotificationManager.error(e.response.data || 'Something Went Wrong!');
	} finally {
		setIsLoading(false);
	}
};

export const changeCompanyProductReducer = async (id, sub_id, isAnnual) => {
	try {
		console.log(id);
		const res = await changeCompanyProduct(id, sub_id, isAnnual);
		if (res.data) {
			NotificationManager.success(res.data);
		}
	} catch (e) {
		console.log(e);
		NotificationManager.error(e.response.data || 'Something Went Wrong!');
	}
};
export const cancelProductReducer = async (
	values,
	callback,
	setIsLoading,
	logoutHandler
) => {
	setIsLoading(true);
	try {
		// const res = await cancelProduct(values);
		if (res.data) {
			NotificationManager.success(res.data);
			callback();
			logoutHandler();
		}
	} catch (e) {
		console.log(e);
		NotificationManager.error(e.response.data || 'Something Went Wrong!');
	} finally {
		setIsLoading(false);
	}
};
